import omit from "lodash-es/omit";

import { formatDaysToDjangoDurationField } from "../due-date-form-helpers";

import type {
  GeneralFormValues,
  GradeFormValues,
  SectionInfoFormValues,
  VirtualClassFormValues,
} from "./types";

import type { SectionType } from "components/server-types";

export const buildGeneralPayload = (formData: GeneralFormValues): Partial<SectionType> => ({
  anonymous_grading_enabled: formData.anonymous_grading_enabled,
  code_blocks_default_language: formData.code_blocks_default_language,
  code_blocks_enabled: formData.code_blocks_enabled,
  section_language: formData.section_language,
  default_late_submission_interval: formatDaysToDjangoDurationField(
    formData.allowLateSubmissions ? formData.daysLate : 0,
  ),
  hide_static_blocks_on_student_response_page: formData.hide_static_blocks_on_student_response_page,
  projector_zoom: formData.projector_zoom,
  should_lock_pages_at_due_date: formData.should_lock_pages_at_due_date,
  student_ai_assistant_enabled: formData.student_ai_assistant_enabled,
  ai_assessment_enabled: formData.ai_assessment_enabled,
});

export const buildSectionInfoPayload = (
  formData: SectionInfoFormValues,
  canAuthorCourse: boolean,
): Partial<SectionType> => {
  const dataWithoutEmptyStrings = {
    ...formData,
    description: formData.description || null,
    external_section_id: formData.external_section_id || null,
  };

  const fieldsToOmit: (keyof SectionInfoFormValues)[] = canAuthorCourse
    ? []
    : ["external_section_id"];

  return omit(dataWithoutEmptyStrings, fieldsToOmit);
};

export const buildGradePayload = (formData: GradeFormValues): Partial<SectionType> => ({
  ...formData,
});

export const buildVirtualClassPayload = (
  formData: VirtualClassFormValues,
): Partial<SectionType> => ({ ...formData });
